module.exports = __webpack_public_path__ + "img/alpha8.0cfcca31.png";